var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",attrs:{"method":_vm.method,"enctype":_vm.enctype,"action":_vm.action,"target":_vm.target,"name":_vm.name,"scope":_vm.scope},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('input',{attrs:{"type":"hidden","name":"_token"},domProps:{"value":_vm.token}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fa35bf6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/forms/FormArea.vue
// module id = null
// module chunks = 